// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: var(--ion-color-subtitle);
  text-align: left !important;
}

.container {
  padding-bottom: 80px;
}

.article-info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.article-info ion-img {
  height: 150px;
}
.article-info h3 {
  padding-top: 10px;
  font-size: 22px;
  color: var(--ion-color-secondary);
  text-align: center !important;
}
.article-info p {
  margin: 15px 0px 10px;
  font-size: 14px;
  color: var(--ion-color-primary);
  font-family: AppFontBold, sans-serif;
}

p {
  line-height: 22px;
}

h1 {
  margin: 0;
  padding: 0 4px;
}

ul {
  padding: 0px;
  text-decoration: none;
  list-style-type: none;
  margin: 0px 0px 10px 0px;
}

li {
  text-decoration: none;
  text-align: left;
  color: var(--ion-color-primary);
  font-size: 14px;
}

ion-icon {
  width: 48px;
  height: 48px;
}

h3 {
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  letter-spacing: 0px;
  color: var(--ion-color-primary);
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 0px;
  right: 0px;
  padding: 10px;
  width: 100%;
}

ion-button {
  margin-top: 15px;
  color: white;
  border-radius: 28px;
  width: 100%;
}

.inner-text {
  text-align: left;
  color: var(--ion-color-primary);
  font-size: 14px;
  margin: 5px 0 6px;
}

.line {
  width: 100%;
  height: 3px;
  margin: 10px 0px;
  fill: var(--ion-color-primary);
}

.cross {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.button-text {
  font-family: Tusker, sans-serif;
  font-size: 18px;
  color: white;
}

.nutrition-value {
  text-align: right !important;
}

.nutrition ion-row {
  padding: 0;
  margin-left: -3px;
}
.nutrition ion-row:first-of-type {
  margin-top: 10px;
}
.nutrition ion-col {
  padding: 5px;
}

.overflow-auto {
  position: relative;
  padding: 8px;
  width: 100%;
  height: 100%;
}

.content-block {
  height: calc(100% - 80px);
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/short-info-modal/short-info-modal.component.scss"],"names":[],"mappings":"AAEA;EACE,gCAAA;EACA,2BAAA;AADF;;AAIA;EAIE,oBAAA;AAJF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AALF;AAME;EACE,aAAA;AAJJ;AAME;EACE,iBAAA;EACA,eAAA;EACA,iCAAA;EACA,6BAAA;AAJJ;AAME;EACE,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,oCAAA;AAJJ;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,SAAA;EACA,cAAA;AALF;;AAOA;EACE,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;AAJF;;AAMA;EACE,qBAAA;EACA,gBAAA;EACA,+BAAA;EACF,eAAA;AAHA;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAcA;EACE,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,+BAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AAXF;;AAaA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAVF;;AAeA;EACE,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAZF;;AAcA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;AAXF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAVF;;AAYA;EACE,+BAAA;EACA,eAAA;EACA,YAAA;AATF;;AAWA;EACE,4BAAA;AARF;;AAYE;EACE,UAAA;EACA,iBAAA;AATJ;AAWI;EACE,gBAAA;AATN;AAYE;EACE,YAAA;AAVJ;;AAaA;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAbF;;AAeA;EACE,yBAAA;EACA,gBAAA;AAZF","sourcesContent":["@import '../../../theme/mixins.scss';\n\n* {\n  color: var(--ion-color-subtitle);\n  text-align: left !important;\n}\n\n.container {\n  // max-height: 80vh;\n  // overflow: auto;\n\n  padding-bottom: 80px;\n\n}\n\n.article-info {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  ion-img {\n    height: 150px;\n  }\n  h3 {\n    padding-top: 10px;\n    font-size: 22px;\n    color: var(--ion-color-secondary);\n    text-align: center !important;\n  }\n  p {\n    margin: 15px 0px 10px;\n    font-size: 14px;\n    color: var(--ion-color-primary);\n    font-family: AppFontBold, sans-serif;\n\n  }\n}\np {\n  line-height: 22px;\n}\n\nh1 {\n  margin: 0;\n  padding: 0 4px;\n}\nul {\n  padding: 0px;\n  text-decoration: none;\n  list-style-type: none;\n  margin: 0px 0px 10px 0px;\n}\nli {\n  text-decoration: none;\n  text-align: left;\n  color: var(--ion-color-primary);\nfont-size: 14px;\n}\nion-icon {\n  width: 48px;\n  height: 48px;\n}\n\n// ion-row {\n//   padding: 8px;\n\n//   text-align: center;\n\n//   ion-col {\n//     padding: 12px;\n//   }\n// }\nh3 {\n  font-size: 16px;\n  font-family: AppFontBold, sans-serif;\n  letter-spacing: 0px;\n  color: var(--ion-color-primary);\n\n}\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 5px;\n  left: 0px;\n  right: 0px;\n  padding: 10px;\n  width: 100%;\n}\nion-button {\n  margin-top: 15px;\n  color: white;\n  border-radius: 28px;\n  width: 100%;\n\n \n\n}\n.inner-text {\n  text-align: left;\n  color: var(--ion-color-primary);\n  font-size: 14px;\n  margin: 5px 0 6px;\n}\n.line {\n  width: 100%;\n  height: 3px;\n  margin: 10px 0px;\n  fill: var(--ion-color-primary);\n}\n.cross {\n  width: 24px;\n  height: 24px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.button-text {\n  font-family: Tusker, sans-serif;\n  font-size: 18px;\n  color: white;\n}\n.nutrition-value {\n  text-align: right !important;\n}\n\n.nutrition {\n  ion-row {\n    padding: 0;\n    margin-left: -3px;\n\n    &:first-of-type {\n      margin-top: 10px;\n    }\n  }\n  ion-col {\n    padding: 5px;\n  }\n}\n.overflow-auto {\n  // @include mobile {\n  //   height: 80vh;\n  // }\n  position: relative;\n  padding: 8px;\n  width: 100%;\n  height: 100%;\n}\n.content-block {\n  height: calc(100% - 80px);\n  overflow-y: auto;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
